<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-9">
              <el-radio v-model="form.type" :label="voucherTypeActivity"
                >ข่าวกิจกรรม</el-radio
              >
              <el-radio v-model="form.type" :label="voucherTypePrivilege"
                >ข่าวสิทธิพิเศษ</el-radio
              >
            </div>
            <div class="col-3 text-end">
              <sc-button variant="primary" @click="handleClickSave"
                >บันทึก</sc-button
              >
            </div>
          </div>
          <voucher-editor
            v-model="form"
            :content-body-json="contentBodyJson"
            :image-url="imageUrl"
            :thumbnail="thumbnailUrl"
            :event-conditions="eventConditions"
            :contentt="form.content"
            @setContent="updateContent($event)"
            @setEventConditions="updateEventConditions($event)"
          ></voucher-editor>
        </div>
        <div class="col-4">
          <voucher-preview
            v-model="form"
            :content-html="contentHtml"
            :image-url="imageUrl"
          ></voucher-preview>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import PageWrapper from "@/lib/components/PageWrapper"
import { baanRueJaiClient } from "@/dependencies"
import { uploadPublicFile, uploadImage, getPublicImageUrl } from "@/god"
import { isEmpty, isNil, toString } from "ramda"
import { voucherType } from "@/lib/mapper"
import { Radio } from "element-ui"
import { fromJSDateToOptionalISODate } from "@/lib/dateTime"
import VoucherPreview from "../components/VoucherPreview"
import VoucherEditor from "../components/VoucherEditor"
import { toVoucherErrorMessage } from "../models/voucherErrorMessage"

export default {
  components: {
    PageWrapper,
    VoucherEditor,
    VoucherPreview,
    "el-radio": Radio,
    "sc-button": ScButton,
  },
  data() {
    const title = "รายละเอียด Lifestyle Voucher"
    const form = {
      type: voucherType.ACTIVITY,
      title: "",
      content: {},
      imageFile: null,
      thumbnailFile: null,
      pdfFile: null,
      fileName: null,
      latitude: 0,
      longitude: 0,
      locationName: "",
      voucherAlbum: [],
      projects: [],
      clientRoles: [],
      event: {
        type: "IMMEDIATE",
        registrationQuestion: null,
        usageType: "ACTIVITY",
        startActivateDate: "",
        endActivateDate: "",
        startUseDate: "",
        endUseDate: "",
        prefixCode: "SC",
        codes: [],
        quota: 1,
        totalReserve: 1,
        showBarcode: true,
        barcodeRemark: null,
      },
    }
    const contentBodyJson = null
    const contentHtml = ""
    const fileUrl = null
    const imageUrl = null
    const thumbnailUrl = null
    const imageKey = null
    const thumbnailKey = null
    const eventConditions = {
      haveRegistrationQuestion: false,
      codeType: "PREFIXED",
      quotaType: "LIMITED",
      showWaitingListOptions: false,
      haveWaitingList: false,
    }

    return {
      title,
      form,
      contentBodyJson,
      contentHtml,
      fileUrl,
      imageUrl,
      thumbnailUrl,
      imageKey,
      thumbnailKey,
      eventConditions,
    }
  },
  computed: {
    voucherTypeActivity() {
      return voucherType.ACTIVITY
    },
    voucherTypePrivilege() {
      return voucherType.PRIVILEGE
    },
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile !== oldForm.imageFile) {
        this.imageUrl = URL.createObjectURL(this.form.imageFile)
      }

      if (this.form.thumbnailFile !== oldForm.thumbnailFile) {
        this.thumbnailUrl = URL.createObjectURL(this.form.thumbnailFile)
      }
    },
    eventConditions() {
      if (!this.eventConditions.haveRegistrationQuestion) {
        this.form.event.registrationQuestion = null
      }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupForm()
    },
    async setupForm() {
      const data = await this.fetchData()

      const {
        title,
        content,
        articlesTypeId,
        cover,
        thumbnail,
        fileName,
        fileUrl,
        latitude,
        longitude,
        locationTitle,
        privilege,
        articlesAlbums,
        articlesProjects,
        ownerStatus,
        renterStatus,
        residentStatus,
        visitorStatus,
      } = data

      const { url: imageUrl } = await getPublicImageUrl(cover)
      const { url: thumbnailUrl } = await getPublicImageUrl(thumbnail)
      const voucherAlbum = await Promise.all(
        articlesAlbums.map(async (file) => {
          const { url } = await getPublicImageUrl(file.image)

          return { key: file.image, url }
        }),
      )
      const clientRoles = Object.entries({
        ownerStatus,
        renterStatus,
        residentStatus,
        visitorStatus,
      })
        .map(([key, value]) => {
          const role = value ? key.replace("Status", "") : null

          return role
        })
        .filter((role) => !isNil(role))

      this.form = {
        ...this.form,
        type: toString(articlesTypeId),
        title,
        imageFile: null,
        thumbnailFile: null,
        fileName,
        latitude,
        longitude,
        locationName: locationTitle,
        voucherAlbum,
        projects: articlesProjects,
        clientRoles,
        event: {
          type: privilege.type,
          usageType: privilege.usageType,
          prefixCode: privilege.prefixCode,
          codes: !isNil(privilege.codes)
            ? privilege.codes
            : this.form.event.codes,
          registrationQuestion: privilege.question,
          quota: !isNil(privilege.quota)
            ? privilege.quota
            : this.form.event.quota,
          totalReserve: !isNil(privilege.totalReserve)
            ? privilege.totalReserve
            : this.form.event.totalReserve,
          startActivateDate: privilege.startActivateDate,
          endActivateDate: privilege.endActivateDate,
          startUseDate: privilege.startUseDate,
          endUseDate: privilege.endUseDate,
          showBarcode: privilege.showBarcode,
          barcodeRemark: privilege.barcodeRemark,
        },
      }

      this.contentBodyJson = JSON.parse(content)
      this.fileUrl = fileUrl
      this.imageUrl = imageUrl
      this.thumbnailUrl = thumbnailUrl
      this.imageKey = cover
      this.thumbnailKey = thumbnail

      this.eventConditions = {
        haveRegistrationQuestion: !isNil(privilege.question),
        codeType: !isNil(privilege.codes) ? "PREDEFINED" : "PREFIXED",
        quotaType: !isNil(privilege.quota) ? "LIMITED" : "UNLIMITED",
        showWaitingListOptions: !isNil(privilege.totalReserve),
        haveWaitingList: !isNil(privilege.totalReserve),
      }
    },
    updateContent(newContent) {
      this.form.content = newContent.contentJson
      this.contentHtml = newContent.contentHtml
    },
    updateEventConditions(newEventConditions) {
      this.eventConditions = newEventConditions
    },
    async fetchData() {
      const { articleId: id } = this.$route.params
      const response = await baanRueJaiClient.admin.articles.get(id)

      return response.data
    },
    async handleClickSave() {
      try {
        await this.updateVoucher()

        this.$router.push({ name: "RuejaiClubVoucherPackageListPage" })
      } catch (error) {
        this.$message.error(
          toVoucherErrorMessage(error, "ไม่สามารถสร้าง Voucher ได้"),
        )
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    async updateVoucher() {
      const { articleId: id } = this.$route.params
      const {
        type,
        title,
        content,
        imageFile,
        thumbnailFile,
        pdfFile,
        fileName,
        latitude,
        longitude,
        locationName,
        voucherAlbum,
        projects,
        clientRoles,
        event,
      } = this.form

      const { codeType, quotaType, haveWaitingList, showWaitingListOptions } =
        this.eventConditions

      let coverImage
      if (imageFile) {
        coverImage = await uploadImage(imageFile, "", "article")
      } else if (!isNil(this.imageKey)) {
        coverImage = this.imageKey
      } else {
        coverImage = null
      }

      let thumbnailImage
      if (thumbnailFile) {
        thumbnailImage = await uploadImage(thumbnailFile, "", "article")
      } else if (!isNil(this.thumbnailKey)) {
        thumbnailImage = this.thumbnailKey
      } else {
        thumbnailImage = null
      }

      const album = !isEmpty(voucherAlbum)
        ? await Promise.all(
            voucherAlbum.map((albumItem) => {
              const imageKey = albumItem.key
                ? albumItem.key
                : uploadImage(albumItem, "", "article")

              return imageKey
            }),
          )
        : null

      let fileUrl
      if (!isNil(pdfFile)) {
        fileUrl = await uploadPublicFile(pdfFile, "article")
      } else if (!isNil(this.fileUrl)) {
        fileUrl = this.fileUrl
      } else {
        fileUrl = null
      }
      const codes = codeType === "PREDEFINED" ? event.codes : null
      const quota = quotaType === "LIMITED" ? event.quota : null
      const totalReserve =
        haveWaitingList && showWaitingListOptions ? event.totalReserve : null
      const startActivateDate =
        typeof event.startActivateDate !== "string"
          ? fromJSDateToOptionalISODate(event.startActivateDate)
          : event.startActivateDate
      const endActivateDate =
        typeof event.endActivateDate !== "string"
          ? fromJSDateToOptionalISODate(event.endActivateDate)
          : event.endActivateDate
      const startUseDate =
        typeof event.startUseDate !== "string"
          ? fromJSDateToOptionalISODate(event.startUseDate)
          : event.startUseDate
      const endUseDate =
        typeof event.endUseDate !== "string"
          ? fromJSDateToOptionalISODate(event.endUseDate)
          : event.endUseDate
      const projectId = projects.map((project) => project.projectId)

      const params = {
        type: +type,
        title,
        content: JSON.stringify(content.ops),
        coverImage,
        thumbnailImage,
        fileUrl,
        fileName,
        latitude: !isEmpty(locationName) ? latitude : null,
        longitude: !isEmpty(locationName) ? longitude : null,
        locationTitle: !isEmpty(locationName) ? locationName : null,
        album,
        projectId,
        clientRole: clientRoles,
        privilege: {
          type: event.type,
          question: event.registrationQuestion,
          usageType: event.usageType,
          startActivateDate,
          endActivateDate,
          startUseDate,
          endUseDate,
          prefixCode: event.prefixCode,
          codes,
          quota,
          totalReserve,
          showBarcode: event.showBarcode,
          barcodeRemark: event.barcodeRemark || null,
        },
      }

      await baanRueJaiClient.admin.articles.put(id, params)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}
</style>
